export const baseUrls = {
  DEVELOPMENT: {
    USER_SERVICE: "https://user-api-qa.worksimpli.io/api/v2/",
    DOCBUILDER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api-qa.worksimpli.io",
    AUTH_SERVICE: "https://auth-api-qa.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api-qa.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api-qa.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://order-api-qa.worksimpli.io/api/",
    ORCHESTRATION_SERVICE: "https://paymentorchestration-qa-v2.azurewebsites.net/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://test-app.pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://test.signsimpli.com/sso/",
    SINGLE_SIGN_ON_RESUMEBUILD: "https://test.worksimpli.io/app/",
    SINGLE_SIGN_ON_LEGASLSIMPLI: "https://test.legalsimpli.com/app/template/sso",
    SINGLE_SIGN_ON_DASHBOARD: "https://test.legalsimpli.com/app/",
    SIGNSIMPLI_URL: "https://test.signsimpli.com",
    PDFSIMPLI_URL: "https://test-app.pdfsimpli.com",
    RESUMEBUILD_URL: "https://test.worksimpli.io",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-qa.worksimpli.io",
    TRUSTPILOT_SERVICE: "",
    ABTEST_SERVICE: "https://abtest-api-qa.pdfsimpli.com",
  },
  QA: {
    USER_SERVICE: "https://user-api-qa.worksimpli.io/api/v2/",
    DOCBUILDER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api-qa.worksimpli.io",
    AUTH_SERVICE: "https://auth-api-qa.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api-qa.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://gw-qa.worksimpli.com/payment/api/v1/",
    ORDER_SERVICE: "https://gw-qa.worksimpli.com/order/api/",
    ORCHESTRATION_SERVICE: "https://gw-qa.worksimpli.com/paymentorchestration/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://test-app.pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://test.signsimpli.com/sso/",
    SINGLE_SIGN_ON_RESUMEBUILD: "https://test.worksimpli.io/app/",
    SINGLE_SIGN_ON_LEGASLSIMPLI: "https://test.legalsimpli.com/app/template/sso",
    SINGLE_SIGN_ON_DASHBOARD: "##LSTemplateAPP_BaseUrl##",
    SIGNSIMPLI_URL: "https://test.signsimpli.com",
    PDFSIMPLI_URL: "https://test-app.pdfsimpli.com",
    RESUMEBUILD_URL: "https://test.worksimpli.io",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-qa.worksimpli.io",
    TRUSTPILOT_SERVICE: "",
    ABTEST_SERVICE: "https://abtest-api-qa.pdfsimpli.com",
  },
  STAGING: {
    USER_SERVICE: "https://user-api.worksimpli.io/api/v2/",
    DOCBUILDER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api.worksimpli.io",
    AUTH_SERVICE: "https://auth-api.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://app-gw-stg.worksimpli.com/payment/api/v1/",
    ORDER_SERVICE: "https://app-gw-stg.worksimpli.com/order/api/",
    ORCHESTRATION_SERVICE: "https://app-gw-stg.worksimpli.com/paymentorchestration/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://signsimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "https://staging.legalsimpli.com/app/",
    SIGNSIMPLI_URL: "https://staging.signsimpli.com",
    PDFSIMPLI_URL: "https://staging.pdfsimpli.com",
    RESUMEBUILD_URL: "https://staging.worksimpli.io",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-api.worksimpli.io",
    TRUSTPILOT_SERVICE: "https://www.trustpilot.com/evaluate/embed/worksimpli.io",
    ABTEST_SERVICE: "https://abtest-api.worksimpli.io",
  },
  PRODUCTION: {
    USER_SERVICE: "https://user-api.worksimpli.io/api/v2/",
    DOCBUILDER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api.worksimpli.io",
    AUTH_SERVICE: "https://auth-api.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://app-gw.worksimpli.com/payment/api/v1/",
    ORDER_SERVICE: "https://app-gw.worksimpli.com/order/api/",
    ORCHESTRATION_SERVICE: "https://app-gw.worksimpli.com/paymentorchestration/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://signsimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "https://legalsimpli.com/app/",
    SIGNSIMPLI_URL: "https://signsimpli.com",
    PDFSIMPLI_URL: "https://pdfsimpli.com",
    RESUMEBUILD_URL: "https://worksimpli.io",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-api.worksimpli.io",
    TRUSTPILOT_SERVICE: "https://www.trustpilot.com/evaluate/embed/worksimpli.io",
    ABTEST_SERVICE: "https://abtest-api.worksimpli.io",
  },
};

//export default baseUrls;
